export const environment = {
   production: true,
   domain: 'auth-fund.vistra.com',
   clientId: 'JxEKLjcg44bK9gUXc4sB7QMfspzpme57',
   audience: 'https://api.star.com',
   scope: 'openid profile email',
   baseUrl: 'https://starportal2.star.vistra.com/prodb-webportal-app-lgc/',
   logout: 'https://starportal2.star.vistra.com/lgc/',
   star_clientid: 'lgc'
};
